module.exports = __webpack_public_path__ + "img/20190806163454819.a178415c.png";